import { queries } from 'src/config/queries';
import { queryClient } from 'src/config/request';
export const removeModuleQueries = (moduleId) => {
    queryClient.removeQueries({
        queryKey: queries.modules.byId(moduleId).queryKey
    });
    queryClient.removeQueries({
        queryKey: [...queries.upload.filesByEntityType._def]
    });
};
